import { render, staticRenderFns } from "./DirectSaleStore.vue?vue&type=template&id=4f194e2a&scoped=true&"
import script from "./DirectSaleStore.vue?vue&type=script&lang=js&"
export * from "./DirectSaleStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f194e2a",
  null
  
)

export default component.exports